import _ from "lodash";
import LocationType from "./../../components/survey/create/SurveyStepActionsKpi/LocationType";
import {
  surveyApiUpsellProvider,
  userApiUpsellProvider,
  assortmentApiUpsellProvider,
  locationApiUpsellProvider,
  sectorsApiUpsellProvider,
  kpiApiUpsellProvider
} from "./../../lib/api/providers";
import {
  SIMULATION_GOTO_LOCATION_TYPES,
  SIMULATION_INIT,
  SIMULATION_RESET,
  SIMULATION_RESET_PAGINATION,
  SIMULATION_SET_EMPLACEMENT_LOCATIONS_TYPES,
  SIMULATION_SET_FIRTPAGE,
  SIMULATION_SET_GENERATED,
  SIMULATION_SET_JSON,
  SIMULATION_SET_KPI_PAGE,
  SIMULATION_SET_LN,
  SIMULATION_SET_LOCATION_TYPES,
  SIMULATION_SET_LTN,
  SIMULATION_SET_PAGINATION_STATE,
  SIMULATION_SET_SN,
  SIMULATION_SET_SURVEY_ANSWERS,
  SIMULATION_SET_SURVEYON,
  SURVEY_UPDATE_LOCATION_TYPES,
  ADD_SURVEY_ELEMENT,
  SURVEY_SET_PROGRESS,
  SURVEY_SET_CURRENT_MODEL,
  ADD_ELEMENT_MLAB,
  SURVEY_PROGRESS_STEPS,
  GET_ALL_USER_MLAB,
  GET_RETAILER_BY_IDRETAILER_IDCLIENT,
  GET_ALL_LOCATION,
  GET_ALL_MODEL_BY_ID,
  GET_ALL_SECTOR,
  GET_ARCHIVE_SURVEY,
  UPDATE_SURVEY,
  GET_ALL_KPI_QUESTIONS_LIST,
  GET_CURRENT_USER_MLAB,
  GET_KPIS_LIST,
  GET_QUESTIONS_BY_KPI,
  GET_SECTORS_LIST,
  GET_SURVEY_ENSEIGNES_LIST,
  GET_SURVEY_LIST,
  GET_SURVEY_MODELES_LIST,
  GET_SURVEY_SECTORS_LIST,
  SURVEY_GET_DYNAMIQUE_FILTER_VALUES,
  SURVEY_SET_CURRENT_FILTERS,
  SURVEY_SET_PAGINATION,
  SET_KEY_SURVEY_FILTER_SELECTED,
  SET_SURVEY_SORT,
  SURVEY_SET_CURRENT_TITLE,
  SURVEY_CREATION_SET_KPISLIST,
  SURVEY_CREATION_SET_ACTIONSLIST,
  SURVEY_CREATION_SET_MODELSLIST,
  SURVEY_DELETE
} from "./../types";
//import { length } from "gl-matrix/src/gl-matrix/vec4";
import {
  SURVEY_CREATION_SET_ACTIONTYPES,
  SURVEY_CREATION_SET_SECTORSLIST,
  SURVEY_PROGRESS_ADD_END_VISIT_STATEMENT,
  SURVEY_PROGRESS_REMOVE_END_VISIT_STATEMENT,
  SURVEY_SET_LIST_LOADING
} from "../types";
import {
  KPI_COM_END_LOCATION_ID,
  KPI_COM_END_VISIT_ID,
  STATEMENT_END_LOCATION_ID,
  STATEMENT_END_VISIT_ID
} from "../../configs/constants";
import { getKpisList } from "../selectors/survey/createSelector";

export const setSurvey = () => {
  return {
    type: GET_SURVEY_LIST
  };
};

export const setKeySurveyFilterSelected = key => {
  return {
    type: SET_KEY_SURVEY_FILTER_SELECTED,
    key
  };
};

export const setSurveyCurrentFilters = currentFilters => {
  return {
    type: SURVEY_SET_CURRENT_FILTERS,
    currentFilters
  };
};

export const setSurveyPagination = (page, pages) => ({
  type: SURVEY_SET_PAGINATION,
  page,
  pages
});

export const getSurvey = data => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(setSurveyPagination(data.page, state.survey.surveyManager.pages));
  };
};

export function updateSurveyFilters(key, filters = []) {
  return (dispatch, getState) => {
    const state = getState();
    let currentFilters = state.survey.surveyManager.currentFilters || {};

    if (!_.isEmpty(filters)) {
      if (key === "SurveyPeriodicity" && filters.startDate && filters.endDate) {
        currentFilters = {
          ...currentFilters,
          "SurveyPeriodicity.startDate": { $gte: { $date: filters.startDate } },
          "SurveyPeriodicity.endDate": { $lte: { $date: filters.endDate } }
        };
      } else currentFilters[key] = filters;
    } else {
      if (key === "SurveyPeriodicity") {
        delete currentFilters["SurveyPeriodicity.startDate"];
        delete currentFilters["SurveyPeriodicity.endDate"];
      } else delete currentFilters[key];
    }
    dispatch(setSurveyCurrentFilters(currentFilters));
    dispatch(getSurvey({ filters: currentFilters, page: 1 }));
  };
}

export const getSurveyDynFilterValues = key => {
  return {
    type: SURVEY_GET_DYNAMIQUE_FILTER_VALUES,
    key
  };
};

export const getSurveySorted = key => {
  return {
    type: SET_SURVEY_SORT,
    key
  };
};

export const setArchiveSurvey = surveyId => {
  return {
    type: GET_ARCHIVE_SURVEY,
    surveyId
  };
};

export const deleteSurvey = id => {
  return {
    type: SURVEY_DELETE,
    id
  };
};

export const setListLoading = loading => {
  return {
    type: SURVEY_SET_LIST_LOADING,
    loading
  };
};
//End of actions that I created (Ornella)

export const getSurveySectorsList = sectorList => {
  return {
    prefixType: GET_SURVEY_SECTORS_LIST,
    callAPI: sectorList
  };
};

export const getSurveyModelesList = modelesList => {
  return {
    prefixType: GET_SURVEY_MODELES_LIST,
    callAPI: modelesList
  };
};

export const getSurveyList = () => {
  return {
    prefixType: GET_SURVEY_LIST,
    callAPI: () => surveyApiUpsellProvider.get(`/findAll`)
  };
};

export const getSurveyEnseignesList = enseigneList => {
  return {
    prefixType: GET_SURVEY_ENSEIGNES_LIST,
    callAPI: enseigneList
  };
};

export const getSectorsList = () => {
  return {
    prefixType: GET_SECTORS_LIST,
    callAPI: () => kpiApiUpsellProvider.get(`/getSectorsList`)
  };
};

export const getQuestionsByKpi = idKpi => {
  return {
    prefixType: GET_QUESTIONS_BY_KPI,
    callAPI: () => kpiApiUpsellProvider.get(`/getQuestionsByKpiId/${idKpi}`),
    payload: { idKpi }
  };
};

export const getKpiList = () => {
  return {
    prefixType: GET_KPIS_LIST,
    callAPI: () => kpiApiUpsellProvider.get(`/findAll`)
  };
};

export const getCurrentUser = currentUser => {
  return {
    prefixType: GET_CURRENT_USER_MLAB,
    callAPI: currentUser
  };
};

export const getAllKpiQuestions = () => {
  return {
    prefixType: GET_ALL_KPI_QUESTIONS_LIST,
    callAPI: () => kpiApiUpsellProvider.get(`/getAllKpiQuestions`)
  };
};

// export const archiveSurvey = data => {
// 	return {
// 		prefixType: ARCHIVE_SURVEY,
// 		callAPI: () => surveyApiUpsellProvider.post(`/archive`, data),
// 	};
// };

export const updateSurvey = data => {
  return {
    prefixType: UPDATE_SURVEY,
    callAPI: () => surveyApiUpsellProvider.put(`/updateSurveyStatus`, data)
  };
};

export const getSector = client => {
  return {
    prefixType: GET_ALL_SECTOR,
    callAPI: () =>
      sectorsApiUpsellProvider.post(`/`, {
        match: { client_id: client },
        project: { _id: 1, sector_id: 1, sector_label: 1 }
      })
  };
};


export const getLocation = (idClient, idRetailer) => {
  return {
    prefixType: GET_ALL_LOCATION,
    callAPI: () => locationApiUpsellProvider.get(`/findByIdClientIdRetailer/${idClient}/${idRetailer}`)
  };
};

export const getByIdClient = idClient => {
  return {
    prefixType: GET_RETAILER_BY_IDRETAILER_IDCLIENT,
    callAPI: () => assortmentApiUpsellProvider.get(`/findByIdClient/${idClient}`)
  };
};

export const getAllUsers = () => {
  return {
    prefixType: GET_ALL_USER_MLAB,
    callAPI: () => userApiUpsellProvider.get(`/findAll`)
  };
};

export const createElement = data => {
  let stringifyElement = JSON.stringify(data);

  return {
    prefixType: ADD_SURVEY_ELEMENT,
    callAPI: () =>
      surveyApiUpsellProvider.post(`/createSurvey`, {
        elements: stringifyElement
      })
  };
};

export const addStepSurvey = survey => {
  return {
    prefixType: SURVEY_PROGRESS_STEPS,
    callAPI: survey
  };
};

export const addElementMlab = data => {
  return {
    prefixType: ADD_ELEMENT_MLAB,
    callAPI: () => userApiUpsellProvider.post(`/createUser`, data)
  };
};

export const addElement = data => {
  return {
    prefixType: ADD_SURVEY_ELEMENT,
    callAPI: () => surveyApiUpsellProvider.post(`/viewer`, data)
  };
};

export const testUpdateSurvey = currentSurvey => ({
  type: ADD_SURVEY_ELEMENT,
  currentSurvey
});

/**
 * set surveyProgress.locationTypes
 * @param [locationType]
 * @returns {*}
 */
export const surveyUpdateLocationTypesProperty = locationTypes => ({
  type: SURVEY_UPDATE_LOCATION_TYPES,
  locationTypes
});

/**
 * set surveyProgress.currentModel
 * @param {Object}
 * @returns {*}
 */
export const surveySetCurrentModel = currentModel => ({
  type: SURVEY_SET_CURRENT_MODEL,
  currentModel
});

export const surveySetCurrentTitle = currentTitle => ({
  type: SURVEY_SET_CURRENT_TITLE,
  currentTitle
});

/**
 * @param {string} operation set/unset
 * @param locationType
 * @returns {*}
 */
export function surveyUpdateLocationTypes(operation, locationType = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const surveyProgress = { ...state.survey.surveyManager.surveyProgress };
    let locationTypes = surveyProgress.locationTypes || [];

    if (operation === "unset") {
      _.remove(locationTypes, { locationTypeId: locationType.locationTypeId });
    } else {
      const locationTypeIndex = _.findIndex(locationTypes, {
        locationTypeId: locationType.locationTypeId
      });
      if (locationTypeIndex === -1) {
        locationTypes.push(locationType);

        //order locationTypes by model order
        const orderedLocationTypes = [];
        const models = surveyProgress.model || [];
        const model = models[0] || {};
        const modelLocations = model.locations || [];

        for (let i = 0; i < modelLocations.length; i++) {
          const modelLocation = modelLocations[i] || {};
          const modelLocationTypeId = modelLocation.locationTypeId;

          const locationType = locationTypes.find(v => v.locationTypeId === modelLocationTypeId);
          if (locationType) {
            orderedLocationTypes.push(locationType);
          }
        }

        locationTypes = orderedLocationTypes;
      } else {
        locationTypes[locationTypeIndex] = {
          ...locationTypes[locationTypeIndex],
          ...locationType
        };
      }
    }
    /*locationTypes.sort(function(a, b) {
			return a.locationTypeId.localeCompare(b.locationTypeId);
		});*/

    dispatch(surveyUpdateLocationTypesProperty(locationTypes));

    dispatch(simulationSetLocationTypes(_.cloneDeep(locationTypes)));

    dispatch(storeSurveyProgress());
  };
}

/**
 * Build locationType instance from locationType data
 * Use data from reducer if exists
 * @param survey
 * @param locationType
 * @returns {LocationType}
 */
function getLocationTypeInstanceFromSurvey(survey = {}, locationType) {
  const surveyProgress = survey.surveyManager.surveyProgress || {};
  const locationTypes = surveyProgress.locationTypes || [];
  const locationTypeIndex = _.findIndex(locationTypes, {
    locationTypeId: locationType.locationTypeId
  });

  let locationTypeInstance;
  if (locationTypeIndex === -1) {
    locationTypeInstance = new LocationType(locationType);
  } else {
    locationTypeInstance = new LocationType(locationTypes[locationTypeIndex]);
  }

  return locationTypeInstance;
}

/**
 * Update statement's label and store into reducer
 * @param locationType
 * @param statement
 * @param label
 * @returns {Function}
 */
export function updateStatementLabel(locationType, statement, label) {
  return (dispatch, getState) => {
    const { survey } = getState();
    let locationTypeInstance = getLocationTypeInstanceFromSurvey(survey, locationType);
    locationTypeInstance.setLabelStatement(statement, label);
    dispatch(surveyUpdateLocationTypes("set", locationTypeInstance.getData()));
  };
}

/**
 * Update statement's actions and store into reducer
 * @param locationType
 * @param statement
 * @param action
 * @param checked
 * @returns {Function}
 */
export function updateStatementActions(locationType, statement, action, checked) {
  return (dispatch, getState) => {
    const { survey } = getState();
    let locationTypeInstance = getLocationTypeInstanceFromSurvey(survey, locationType);
    locationTypeInstance.updateActionStatement(statement, action, checked);
    dispatch(surveyUpdateLocationTypes("set", locationTypeInstance.getData()));
  };
}

/**
 * Add Kpi to statement and store into reducer
 * @param locationType
 * @param statement
 * @param kpi
 * @returns {Function}
 */
export function addKpi(locationType, statement, kpi) {
  return (dispatch, getState) => {
    const { survey } = getState();
    let locationTypeInstance = getLocationTypeInstanceFromSurvey(survey, locationType);
    locationTypeInstance.addKpi(statement, kpi);
    dispatch(surveyUpdateLocationTypes("set", locationTypeInstance.getData()));
  };
}

/**
 * Remove Kpi from statement and store into reducer
 * @param locationType
 * @param statement
 * @param kpi
 * @returns {Function}
 */
export function removeKpi(locationType, statement, kpi) {
  return (dispatch, getState) => {
    const { survey } = getState();
    let locationTypeInstance = getLocationTypeInstanceFromSurvey(survey, locationType);
    locationTypeInstance.removeKpi(statement, kpi);
    dispatch(surveyUpdateLocationTypes("set", locationTypeInstance.getData()));
  };
}

/**
 * Add end location action
 * @param locationType
 * @returns {Function}
 */
export function addEndLocationAction(locationType) {
  return (dispatch, getState) => {
    const { survey } = getState();
    const kpis = getKpisList(getState());
    const commentKpi = _.find(kpis, { id: KPI_COM_END_LOCATION_ID });

    let locationTypeInstance = getLocationTypeInstanceFromSurvey(survey, locationType);
    locationTypeInstance.addEndLocationStatement();
    const statement = locationTypeInstance.getStatement(STATEMENT_END_LOCATION_ID + "");
    locationTypeInstance.addKpi(statement, commentKpi);
    dispatch(surveyUpdateLocationTypes("set", locationTypeInstance.getData()));
  };
}

/**
 * remove end location action
 * @param locationType
 * @returns {Function}
 */
export function removeEndLocationAction(locationType) {
  return (dispatch, getState) => {
    const { survey } = getState();
    let locationTypeInstance = getLocationTypeInstanceFromSurvey(survey, locationType);
    locationTypeInstance.addEndLocationStatement();
    const statement = locationTypeInstance.getStatement(STATEMENT_END_LOCATION_ID + "");
    locationTypeInstance.removeStatement(statement);
    dispatch(surveyUpdateLocationTypes("set", locationTypeInstance.getData()));
  };
}

/**
 * Add end visit action
 * @returns {Function}
 */
export function addEndVisitStatementAction() {
  return (dispatch, getState) => {
    const state = getState();
    const kpis = getKpisList(state);
    const commentKpi = _.find(kpis, { id: KPI_COM_END_VISIT_ID });

    const statement = {
      _id: "",
      client_id: [],
      actions: [],
      id: STATEMENT_END_VISIT_ID,
      label: "Fin de visite",
      description: "Fin de visite",
      condition: false,
      question: "Fin de visite",
      format: "Boolean",
      display: true,
      type: "inline",
      priority: 1,
      __v: 0,
      title: "Fin de visite",
      statementId: STATEMENT_END_VISIT_ID + "",
      displayType: "inline",
      conditions: [],
      conditionStatus: true,
      medias: [],
      mediaQuantity: [
        {
          type: "Photo",
          quantity: "0"
        }
      ],
      kpis: [commentKpi]
    };

    dispatch(addEndVisitStatement(statement));
    dispatch(storeSurveyProgress());
  };
}

/**
 * Remove end visit action
 * @returns {Function}
 */
export function removeEndVisitStatementAction() {
  return dispatch => {
    dispatch(removeEndVisitStatement());
    dispatch(storeSurveyProgress());
  };
}

/**
 * Update media values and store into reducer
 * @param locationType
 * @param statement
 * @param type
 * @param value
 * @returns {Function}
 */
export function updateMediaValue(locationType, statement, type, value) {
  return (dispatch, getState) => {
    const { survey } = getState();
    let locationTypeInstance = getLocationTypeInstanceFromSurvey(survey, locationType);
    locationTypeInstance.setMediaValue(statement, type, value);
    dispatch(surveyUpdateLocationTypes("set", locationTypeInstance.getData()));
  };
}

/**
 * Update display type and store into reducer
 * @param locationType
 * @param statement
 * @param value
 * @returns {Function}
 */
export function updateDisplayType(locationType, statement, value) {
  return (dispatch, getState) => {
    const { survey } = getState();
    let locationTypeInstance = getLocationTypeInstanceFromSurvey(survey, locationType);
    const displayType = value ? "matrix" : "inline";
    locationTypeInstance.setDisplayType(statement, displayType);

    dispatch(surveyUpdateLocationTypes("set", locationTypeInstance.getData()));
    dispatch(setKpiPage(0));
  };
}

/**
 * Load form progression from local storage
 * @returns {Function}
 */
export function loadSurveyProgress(data) {
  return dispatch => {
    if (data) {
      try {
        const dataObj = JSON.parse(data);
        if (dataObj.surveyProgress && dataObj.simulationManager) {
          dispatch(setSurveyProgress(dataObj.surveyProgress));
          dispatch(initSimulation(dataObj.simulationManager));
        }
      } catch (e) {}
    }
  };
}

export const setSurveyProgress = surveyProgress => ({
  type: SURVEY_SET_PROGRESS,
  surveyProgress
});

/**
 * Store form progression to local storage
 * @returns {Function}
 */
export function storeSurveyProgress() {
  return (dispatch, getState) => {
    const { survey } = getState();
    const data = {
      surveyProgress: survey.surveyManager.surveyProgress,
      simulationManager: survey.simulationManager
    };
    localStorage.setItem("upsell_survey_progress", JSON.stringify(data));
  };
}

/**
 * Remove progression from local storage
 * @returns {Function}
 */
export function removeSurveyProgress() {
  return () => {
    localStorage.removeItem("upsell_survey_progress");
  };
}

export default testUpdateSurvey;

export const initSimulation = simulationManager => ({
  type: SIMULATION_INIT,
  simulationManager
});

export const setJSON = json => ({
  type: SIMULATION_SET_JSON,
  json
});

export const setGenerated = isSurveyGenerated => {
  return {
    type: SIMULATION_SET_GENERATED,
    isSurveyGenerated
  };
};

export const setLTN = ltN => ({
  type: SIMULATION_SET_LTN,
  ltN
});

export const setKpiPage = kpiPage => ({
  type: SIMULATION_SET_KPI_PAGE,
  kpiPage
});

export const setlN = lN => ({
  type: SIMULATION_SET_LN,
  lN
});

export const setSN = sN => ({
  type: SIMULATION_SET_SN,
  sN
});

export const setFirstPage = firstPage => ({
  type: SIMULATION_SET_FIRTPAGE,
  firstPage
});

export const setSurveyON = surveyOn => ({
  type: SIMULATION_SET_SURVEYON,
  surveyOn
});

export const setSurveyAnswers = (surveyAnswers = []) => ({
  type: SIMULATION_SET_SURVEY_ANSWERS,
  surveyAnswers
});

export const simulationSetLocationTypes = (locationTypes = []) => ({
  type: SIMULATION_SET_LOCATION_TYPES,
  locationTypes
});

export const simulationSetEmplacementLocationsTypes = (locationsTypes = []) => ({
  type: SIMULATION_SET_EMPLACEMENT_LOCATIONS_TYPES,
  locationsTypes
});

export const setPaginationState = (ltN, lN, sN, firstPage, mediaPage = -1, kpiPage = 0) => ({
  type: SIMULATION_SET_PAGINATION_STATE,
  ltN,
  lN,
  sN,
  firstPage,
  mediaPage,
  kpiPage
});

export const resetPagination = () => ({
  type: SIMULATION_RESET_PAGINATION
});

export const reset = () => ({
  type: SIMULATION_RESET
});

export const gotoLocationType = ltN => ({
  type: SIMULATION_GOTO_LOCATION_TYPES,
  ltN
});

export const setKpisList = (kpis = []) => ({
  type: SURVEY_CREATION_SET_KPISLIST,
  kpis
});

export const setActionsList = (actions = []) => ({
  type: SURVEY_CREATION_SET_ACTIONSLIST,
  actions
});
export const setActionTypes = (statements = []) => ({
  type: SURVEY_CREATION_SET_ACTIONTYPES,
  statements
});
export const setSectorsList = (sectors = []) => ({
  type: SURVEY_CREATION_SET_SECTORSLIST,
  sectors
});
export const setModelsList = (models = []) => ({
  type: SURVEY_CREATION_SET_MODELSLIST,
  models
});

//surveyProgress.end_visit_statement
export const addEndVisitStatement = statement => ({
  type: SURVEY_PROGRESS_ADD_END_VISIT_STATEMENT,
  statement
});
export const removeEndVisitStatement = () => ({
  type: SURVEY_PROGRESS_REMOVE_END_VISIT_STATEMENT
});



// WEBPACK FOOTER //
// src/redux/actions/surveyActions.js